<template>
    <div>
      <VueApexCharts
        ref="chartComponent"
        type="area"
        :options="chartOptions"
        :series="translatedSeries"
        height="350"
      />
    </div>
  </template>
  
  <script>
  import VueApexCharts from "vue-apexcharts";
  
  export default {
    components: {
      VueApexCharts,
    },
    props: {
      series: { type: Array, default: () => [] },
      labels: { type: Array, default: () => [] }, // dynamic date labels from API
    },
    data() {
      return {
        chartOptions: this.getChartOptions(),
      };
    },
    computed: {
      translatedSeries() {
        return this.series.map((serie) => ({
          ...serie,
          name: this.$t(serie.name),
        }));
      },
    },
    watch: {
      labels: {
        immediate: true,
        handler() {
          this.updateChartOptions();
        },
      },
      "$i18n.locale": {
        immediate: true,
        handler() {
          this.updateChartTranslations();
        },
      },
    },
    methods: {
      getChartOptions() {
        return {
          chart: {
            type: "area",
            height: 350,
            toolbar: {
              tools: {
                download: true,
              },
            },
            events: {
              mounted: () => {
                this.updateToolbarTranslations();
              },
              updated: () => {
                this.updateToolbarTranslations();
              },
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
          },
          xaxis: {
            type: "category",
            categories: this.labels,
            labels: {
              rotate: -45,
            },
          },
  
          yaxis: {
            tickAmount: 4,
            forceNiceScale: true,
            labels: {
              formatter: (value) => (Number.isInteger(value) ? value : ""),
            },
          },
          legend: {
            show: false,
          },
          tooltip: {
            x: {
              format: "dd/MM/yy",
            },
            y: {
              formatter: (value) => `${value}`,
            },
          },
        };
      },
      updateChartOptions() {
        if (this.$refs.chartComponent) {
          this.$refs.chartComponent.chart.updateOptions({
            xaxis: {
              categories: this.labels.map((label, index) =>
                index % 3 === 0 ? label : ""
              ),
              labels: {
                rotate: -45,
              },
            },
            tooltip: {
              x: {
                // Let tooltip show full date from data point, not the sparse label
                formatter: (value, { dataPointIndex }) => {
                  return this.labels[dataPointIndex] || ""; // Full label
                },
              },
            },
          });
        }
        this.updateToolbarTranslations();
      },
      updateChartTranslations() {
        this.updateChartOptions();
      },
      updateToolbarTranslations() {
        const toolbarItems = document.querySelectorAll(".apexcharts-menu-item");
        toolbarItems.forEach((item) => {
          if (item.classList.contains("exportSVG")) {
            item.innerText = this.$t("downloadSvg");
          } else if (item.classList.contains("exportPNG")) {
            item.innerText = this.$t("downloadPng");
          } else if (item.classList.contains("exportCSV")) {
            item.innerText = this.$t("downloadCsv");
          }
        });
      },
    },
    mounted() {
      this.updateChartTranslations();
    },
  };
  </script>
  